module.exports = __webpack_public_path__ + "assets/img/2803.510ddcb5.svg";